<script lang="ts" setup>
	import type { BlogPostContext } from '~/server/type'

	const props = defineProps<{
		posts: BlogPostContext[]
		currentId?: string | number
	}>()

	const relatedPosts = computed(() => {
		return props.posts.filter(p => p.id !== props.currentId)
	})
</script>

<template>
	<div v-if="relatedPosts.length" class="pt-8 md:pt-[64px] border-t-[4px] border-gray-300">
		<h5 class="flexed justify-center text-center text-gray-700 sm:text-2xl text-xl pb-[32px] font-bold">
			Related Articles
		</h5>
		<ul>
			<li
				v-for="(post, index) in relatedPosts"
				:key="`related-post-${index + 1}`"
				class="w-full border-b bg-white first:rounded-t-md custom-transition-3 hover:bg-[#DAF1EB] group last:rounded-b-md"
			>
				<nuxt-link
					:to="`/product-guide/${post.categories[0]?.id ?? post.id}-${post.slug}?q=${post.id}`"
					class="py-3 md:px-6 md:py-4 flex items-center justify-between"
				>
					<span
						class="font-medium sm:text-xl text-lg text-gray-700 group-hover:text-gray-800 transition-all ease-linear"
					>
						{{ post.title }}
					</span>
					<tools-icon
						dir="arrows"
						icon="caret-down"
						class="-rotate-90"
						path-class="stroke-gray-700"
						:height="24"
						:width="24"
					/>
				</nuxt-link>
			</li>
		</ul>
	</div>
</template>
